import React from "react";
import { useLocation } from "react-router-dom";

interface BreadcrumbItem {
  name: string;
  url: string;
}

const BreadcrumbSchema: React.FC = () => {
  const location = useLocation();

  React.useEffect(() => {
    const getBreadcrumbs = (): BreadcrumbItem[] => {
      const pathSegments = location.pathname.split('/').filter(Boolean);
      const breadcrumbs: BreadcrumbItem[] = [
        { name: "Home", url: `${window.location.origin}/` }
      ];

      let currentPath = '';
      pathSegments.forEach((segment, index) => {
        currentPath += `/${segment}`;
        
        // Convert path segment to readable name
        let name = segment;
        switch (segment) {
          case 'spharakaxdr':
            name = 'Spharaka XDR™';
            break;
          case 'auraxp':
            name = 'AuraXP™ Technology';
            break;
          case 'blogs':
            name = 'Blog';
            break;
          case 'ultimate-guide-ai-xdr':
            name = 'Ultimate Guide to AI-Powered XDR';
            break;
          case 'why-spharaka':
            name = 'Why Spharaka';
            break;
          case 'contact':
            name = 'Contact Us';
            break;
          default:
            name = segment.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        }

        breadcrumbs.push({
          name,
          url: `${window.location.origin}${currentPath}`
        });
      });

      return breadcrumbs;
    };

    const breadcrumbs = getBreadcrumbs();
    
    if (breadcrumbs.length > 1) {
      const schema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": breadcrumbs.map((item, index) => ({
          "@type": "ListItem",
          "position": index + 1,
          "name": item.name,
          "item": item.url
        }))
      };

      const scriptTag = document.createElement('script');
      scriptTag.type = 'application/ld+json';
      scriptTag.textContent = JSON.stringify(schema);
      document.head.appendChild(scriptTag);

      return () => {
        try {
          document.head.removeChild(scriptTag);
        } catch (e) {
          // Element may have already been removed
        }
      };
    }
  }, [location]);

  return null;
};

export default BreadcrumbSchema;